import ConfigManager from "@/config/ConfigManager.js";
import BzbsApi from "@/core/Http/BzbsApi.js";
import { map } from "rxjs/operators";

/**
 * @method apiGetPDPAVersion
 * @method apiGetPDPAContent
 */

export default {
    /**
     * Return PDPA version
     */
    apiGetPDPAVersion: function() {
        let appId = ConfigManager.getAppId();
        let url = ConfigManager.getBlobUrl() + `/pdpaconsent/${appId}/version`;
        return BzbsApi.connectBzbsGetBlob(url).pipe(map(res => res.data));
    },

    /**
     * Return PDPA contents.
     * @param {String} contentType Terms, privacy, etc..
     * @param {Number} version PDPA content version
     * @param {Number} language PDPA language code.
     */
    apiGetPDPAContent: function(contentType, version, language) {
        const appId = ConfigManager.getAppId();
        const url = ConfigManager.getBlobUrl()  + `/pdpaconsent/${appId}/${contentType}/${version}/${language}.txt`;
        return BzbsApi.connectBzbsGetBlob(url).pipe(map(res => res.data));
    },

    /**
     * @param {string} token
     * @param {number|string} termandcondition
     * @param {number|string} dataprivacy
     */
    apiPostConsent: function(token, termandcondition, dataprivacy) {
        let params = {
            termandcondition: termandcondition,
            dataprivacy: dataprivacy
        };
        let url = ConfigManager.getApiUrl() + "/consent";
        return BzbsApi.connectBzbsPost(url, token, params).pipe(map(res => res.data));
    }
};
